export default __webpack_public_path__ + "static/media/discover.1b8da20a.png";